// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import exportWishList from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/ExportWishList";
import { makeHandlerChainAwaitable } from "@toolkit/Modules/client-framework/HandlerCreator";

import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { getCurrentAccountState } from "@insite/client-framework/Store/Data/Accounts/AccountsSelector";
import {
    canAddWishListLineToCart,
    getWishListLinesDataView,
} from "@insite/client-framework/Store/Data/WishListLines/WishListLinesSelectors";
import { getWishListState } from "@insite/client-framework/Store/Data/WishLists/WishListsSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import addLinesToCart from "@insite/client-framework/Store/Pages/Cart/Handlers/AddLinesToCart";
import addWishListToCart from "@insite/client-framework/Store/Pages/Cart/Handlers/AddWishListToCart";
import deleteWishList from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/DeleteWishList";
import deleteWishListLines from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/DeleteWishListLines";
import loadWishListLines from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/LoadWishListLines";
import loadWishLists from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/LoadWishLists";
import setAllWishListLinesIsSelected from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/SetAllWishListLinesIsSelected";
import updateLoadWishListLinesParameter from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/UpdateLoadWishListLinesParameter";
import translate from "@insite/client-framework/Translate";
import { CartLineCollectionModel, CartLineModel, WishListLineModel } from "@insite/client-framework/Types/ApiModels";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import TwoButtonModal from "@insite/content-library/Components/TwoButtonModal";
import MyListsEditListForm from "@insite/content-library/Widgets/MyLists/MyListsEditListForm";
import Button from "@insite/mobius/Button";
import { Hidden } from "@insite/mobius/index";
import Modal from "@insite/mobius/Modal";
import { useToaster } from "@insite/mobius/Toast/ToasterContext";
import Typography from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import useBuyingList from "@store/Framework/Common/Hooks/useBuyingList/useBuyingList";
import useIsMobile from "@store/Framework/Common/Hooks/useIsMobile";
import { deleteBuyingList } from "@store/Framework/Services/RestrictedBuyingListService";
import { CustomWidgetModule } from "@store/Framework/Types/types";

import exportBuyingList from "@store/Framework/Store/Bunzl/Handlers/ExportBuyingList";
import ManageProductsModal from "@store/Library/Components/BuyingList/ManageProductsModal";
import ManageUsersModal from "@store/Library/Components/BuyingList/ManageUsersModal/ManageUsersModal";
import StoreAddToCartRestrictionsMessage from "@store/Library/Components/Foundation/StoreAddToCartRestrictionsMessage";
import { actionStyles } from "@store/Overrides/Widgets/MyListsDetails/MyListsDetailsActions";
import { getMediaQuery } from "@toolkit/Framework/Common/Utilities/mediaQueries";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mobileQuery = getMediaQuery({ option: "only", first: true, min: 0, max: 600, last: false });

const mapStateToProps = (state: ApplicationState) => {
    const { isUpdatingCart } = state.context;
    const wishListLinesDataView = getWishListLinesDataView(state, state.pages.myListDetails.loadWishListLinesParameter);
    const wishListLines = wishListLinesDataView.value || [];
    const selectedWishListLineIds = state.pages.myListDetails.selectedWishListLineIds;
    const linesToAddToCart = selectedWishListLineIds.length
        ? wishListLines.filter(x => selectedWishListLineIds.includes(x.id))
        : wishListLines;
    const restrictedLines = linesToAddToCart.filter(x => !x.canAddToCart);

    return {
        isUpdatingCart,
        wishList: getWishListState(state, state.pages.myListDetails.wishListId).value,
        wishListLinesDataView: getWishListLinesDataView(state, state.pages.myListDetails.loadWishListLinesParameter),
        wishListSettings: getSettingsCollection(state).wishListSettings,
        selectedWishListLineIds: state.pages.myListDetails.selectedWishListLineIds,
        myListsPageLink: getPageLinkByPageType(state, "BuyingListPage"),
        allowEditingOfWishLists: getSettingsCollection(state).wishListSettings.allowEditingOfWishLists,
        productInfosByWishListLineId: state.pages.myListDetails.productInfosByWishListLineId,
        restrictedLines,
        linesAllRestricted: restrictedLines.length === linesToAddToCart.length,
    };
};

const mapDispatchToProps = {
    addWishListToCart,
    addLinesToCart,
    deleteWishList,
    deleteWishListLines,
    loadWishLists,
    loadWishListLines: makeHandlerChainAwaitable(loadWishListLines),
    updateLoadWishListLinesParameter,
    exportBuyingList,
};

type BuyingListActionsProps = WidgetProps &
    HasHistory &
    ResolveThunks<typeof mapDispatchToProps> &
    ReturnType<typeof mapStateToProps>;

const styles = actionStyles;
interface BuyingListActionExtendedStyles {
    leftSection: InjectableCss;
    actionRow: InjectableCss;
    rightButtonsRowWrapper: InjectableCss;
    wrapper: InjectableCss;
}
const extendedStyles: BuyingListActionExtendedStyles = {
    leftSection: {
        css: css`
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            width: 50%;
            ${mobileQuery} {
                width: 100%;
            }
            gap: 1.5rem;
        `,
    },
    actionRow: {
        css: css`
            display: flex;
            width: 100%;
            gap: 1rem;
            ${mobileQuery} {
                justify-content: center;
                align-items: center;
            }
        `,
    },
    rightButtonsRowWrapper: {
        css: css`
            display: flex;
            max-width: 50%;
            gap: 1rem;
            justify-content: center;
            flex-wrap: wrap;
            ${mobileQuery} {
                width: 100%;
                max-width: unset;
                flex-direction: column;
            }
        `,
    },
    wrapper: {
        css: css`
            display: flex;
            flex-wrap: wrap;
            align-items: flex-start;
            justify-content: space-between;
            ${mobileQuery} {
                gap: 1rem;
            }
        `,
    },
};
const BuyingListActions: React.FC<BuyingListActionsProps> = ({
    selectedWishListLineIds,
    restrictedLines,
    addWishListToCart,
    productInfosByWishListLineId,
    wishListLinesDataView,
    wishList,
    isUpdatingCart,
    deleteWishListLines,
    allowEditingOfWishLists,
    addLinesToCart,
    linesAllRestricted,
    myListsPageLink,
    history,
    exportBuyingList,
}) => {
    const [deleteListModalIsOpen, setDeleteListModalIsOpen] = React.useState(false);
    const [deleteListItemsModalIsOpen, setDeleteListItemsModalIsOpen] = React.useState(false);
    const [productModalIsOpen, setProductModalIsOpen] = React.useState(false);
    const [confirmModalIsOpen, setConfirmModalIsOpen] = React.useState(false);
    const [userModalIsOpen, setUserModalIsOpen] = React.useState(false);
    const toast = useToaster();
    const isMobile = useIsMobile();
    const { getBuyingLists, activeBuyingList, activeWishList, updateBuyingLists } = useBuyingList();
    const isAdmin = useAppSelector(state => getCurrentAccountState(state)?.value?.role === "Administrator");

    const displayToast = (message: React.ReactNode) => {
        toast.addToast({ body: message, messageType: "success" });
    };
    const deleteClickHandler = () => {
        setDeleteListModalIsOpen(true);
    };
    const linesSelected = () => {
        return selectedWishListLineIds.length > 0;
    };
    const enableAddToCart = () => {
        const lines = wishListLinesDataView.value;
        return (
            wishList?.canAddToCart &&
            lines?.some(o => canAddWishListLineToCart(o, productInfosByWishListLineId)) &&
            allQuantitiesAreValid(lines)
        );
    };
    const allQuantitiesAreValid = (wishListLines: WishListLineModel[]) => {
        return wishListLines
            .filter(o => selectedWishListLineIds.length === 0 || selectedWishListLineIds.indexOf(o.id) > -1)
            .every(o => o.qtyOrdered && parseFloat(o.qtyOrdered.toString()) > 0);
    };

    const removeSelectedClickHandler = () => {
        setDeleteListItemsModalIsOpen(true);
    };

    const addToCartClickHandler = (e: any, hasConfirm = false) => {
        e.preventDefault();
        if (!wishList || !wishListLinesDataView.value) {
            return;
        }

        if (restrictedLines.length && !hasConfirm) {
            setConfirmModalIsOpen(true);
            return;
        }

        if (linesSelected()) {
            const selectedLines = wishListLinesDataView.value.filter(o => selectedWishListLineIds.indexOf(o.id) > -1);
            const linesToAdd = selectedLines.filter(
                o =>
                    o.quoteRequired ||
                    o.allowZeroPricing ||
                    productInfosByWishListLineId[o.id]?.pricing?.unitNetPrice !== 0,
            );

            if (linesToAdd.length === 0) {
                toast.addToast({ body: siteMessage("Cart_InvalidPrice"), messageType: "danger" });
                return;
            }

            addLinesToCart({
                apiParameter: {
                    cartId: API_URL_CURRENT_FRAGMENT,
                    cartLineCollection: {
                        cartLines: linesToAdd.map(o => o as any as CartLineModel),
                    } as CartLineCollectionModel,
                },
                onSuccess: () => {
                    onAddToCartSuccess({
                        notAllAddedToCart: linesToAdd.length !== selectedLines.length,
                    } as CartLineCollectionModel);
                },
                onComplete(resultProps) {
                    if (resultProps.apiResult) {
                        this.onSuccess?.();
                    }
                },
            });
        } else {
            addWishListToCart({
                apiParameter: {
                    wishListId: wishList.id,
                },
                onSuccess: onAddToCartSuccess,
                onComplete(resultProps) {
                    if (resultProps.apiResult) {
                        this.onSuccess?.(resultProps.apiResult);
                    }
                },
            });
        }
    };

    function onAddToCartSuccess(apiResult?: CartLineCollectionModel) {
        displayToast(
            linesSelected()
                ? translate("Added to Cart")
                : apiResult?.notAllAddedToCart
                ? siteMessage("Lists_Items_Not_All_Added_To_Cart")
                : translate("List Added to Cart"),
        );
    }
    const onDeleteSuccess = async () => {
        await getBuyingLists(true);
        displayToast(translate("List Deleted"));
        myListsPageLink && history.push(myListsPageLink.url);
    };
    const deleteSubmitHandler = async () => {
        if (!activeBuyingList) {
            return;
        }
        setDeleteListItemsModalIsOpen(false);

        await deleteBuyingList(activeBuyingList.id);
        onDeleteSuccess();
    };

    const onRemoveSelectedSuccess = async () => {
        await getBuyingLists(true);
        displayToast(translate(`Item${selectedWishListLineIds.length > 1 ? "s" : ""} Deleted`));
        setAllWishListLinesIsSelected({ isSelected: false });
    };
    const removeSelectedSubmitHandler = () => {
        if (!wishList) {
            return;
        }
        setDeleteListItemsModalIsOpen(false);
        const wishListLineIds =
            wishListLinesDataView?.value?.filter(o => selectedWishListLineIds.indexOf(o.id) > -1).map(o => o.id) || [];
        if (wishListLineIds && activeWishList) {
            updateBuyingLists(activeWishList, { itemsToRemove: wishListLineIds });
            setAllWishListLinesIsSelected({ isSelected: false });
        }
    };

    const showAddToCart = (wishListLinesDataView.value?.length || 0) > 0;

    const addToCartCancelHandler = () => {
        setConfirmModalIsOpen(false);
    };
    const addToCartSubmitHandler = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
        setConfirmModalIsOpen(false);
        addToCartClickHandler(event, true);
    };

    const showRemoveSelected = (wishList?.allowEdit || !wishList?.isSharedList) && linesSelected() && isAdmin;
    const addListToCartButtonText = linesSelected() ? translate("Add Selected to Cart") : translate("Add List to Cart");
    const showDelete = allowEditingOfWishLists && isAdmin;
    return (
        <>
            <ManageUsersModal
                buyingList={activeWishList || null}
                isOpen={userModalIsOpen}
                onClose={() => setUserModalIsOpen(false)}
                selectedUsers={[]}
            />
            <ManageProductsModal
                buyingList={activeWishList || null}
                isOpen={productModalIsOpen}
                onClose={() => setProductModalIsOpen(false)}
            />
            <StyledWrapper {...extendedStyles.wrapper} data-test-selector="buyingListActions_wrapper">
                <StyledWrapper {...extendedStyles.leftSection} data-test-selector="buyingListActions_leftSection">
                    <Typography
                        variant={isMobile ? "h3" : "h2"}
                        css={css`
                            margin: 0;
                            word-break: break-all;
                            max-width: 100%;
                        `}
                        data-test-selector="buyingListActions_listName"
                    >
                        {wishList?.name}
                    </Typography>
                    {wishList?.description && (
                        <Hidden below="md">
                            <Typography
                                css={css`
                                    font-weight: 700;
                                    color: ${getColor("text.accent")};
                                `}
                                data-test-selector="buyingListActions_descriptionLabel"
                            >
                                {translate("Description")}
                            </Typography>
                            <Typography variant="h4" data-test-selector="buyingListActions_description">
                                {wishList?.description}
                            </Typography>
                        </Hidden>
                    )}
                    <StyledWrapper {...extendedStyles.actionRow} data-test-selector="buyingListActions_actionRow">
                        {isAdmin && (
                            <>
                                <Button
                                    {...styles.addListButton}
                                    onClick={() => setProductModalIsOpen(true)}
                                    data-test-selector="buyingListActions_manageProductsButton"
                                >
                                    {translate("Manage Products")}
                                </Button>
                                <Button
                                    onClick={() => setUserModalIsOpen(true)}
                                    data-test-selector="buyingListActions_manageUsersButton"
                                >
                                    {translate("Manage Users")}
                                </Button>
                            </>
                        )}
                    </StyledWrapper>
                </StyledWrapper>
                <StyledWrapper
                    {...extendedStyles.rightButtonsRowWrapper}
                    data-test-selector="buyingListActions_rightButtonsWrapper"
                >
                    {showRemoveSelected ? (
                        <Button
                            {...styles.removeSelectedButton}
                            onClick={removeSelectedClickHandler}
                            data-test-selector="buyingListActions_removeSelectedButton"
                        >
                            {translate("Remove Selected")}
                        </Button>
                    ) : null}

                    <Button
                        disabled={!enableAddToCart() || !showAddToCart || isUpdatingCart}
                        {...styles.addListButton}
                        onClick={addToCartClickHandler}
                        data-test-selector="buyingListActions_addToCartButton"
                    >
                        {addListToCartButtonText}
                    </Button>

                    {showDelete ? (
                        <Button
                            onClick={deleteClickHandler}
                            {...styles.deleteButton}
                            data-test-selector="buyingListActions_deleteButton"
                        >
                            {translate("Delete List")}
                        </Button>
                    ) : null}
                    {wishList && (
                        <Button
                            {...styles.deleteButton}
                            onClick={() => exportBuyingList({ wishListId: wishList.id })}
                            data-test-selector="buyingListActions_exportButton"
                        >
                            {translate("Export List")}
                        </Button>
                    )}
                </StyledWrapper>
                <TwoButtonModal
                    headlineText={translate("Delete List")}
                    {...styles.deleteListModal}
                    modalIsOpen={deleteListModalIsOpen}
                    messageText={`${translate("Are you sure you want to delete")} ${wishList?.name}?`}
                    cancelButtonText={translate("Cancel")}
                    submitButtonText={translate("Delete")}
                    onCancel={() => setDeleteListModalIsOpen(false)}
                    onSubmit={deleteSubmitHandler}
                    submitTestSelector="buyingListActions_deleteModal_submit"
                    data-test-selector="buyingListActions_deleteModal"
                ></TwoButtonModal>
                <TwoButtonModal
                    headlineText={translate("Add to Cart")}
                    modalIsOpen={confirmModalIsOpen}
                    messageText={
                        <StoreAddToCartRestrictionsMessage
                            list={restrictedLines.map(x => x.shortDescription)}
                            isAll={linesAllRestricted}
                        />
                    }
                    cancelButtonText={translate("Cancel")}
                    submitButtonText={translate("Continue")}
                    onCancel={addToCartCancelHandler}
                    onSubmit={addToCartSubmitHandler}
                    data-test-selector="buyingListActions_addToCartConfirmModal"
                />

                <TwoButtonModal
                    headlineText={translate(`Remove Item${selectedWishListLineIds.length > 1 ? "s" : ""}`)}
                    {...styles.deleteListItemsModal}
                    modalIsOpen={deleteListItemsModalIsOpen}
                    messageText={translate(
                        `Are you sure you want to remove ${
                            selectedWishListLineIds.length > 1 ? "these items" : "this item"
                        }?`,
                    )}
                    cancelButtonText={translate("Cancel")}
                    submitButtonText={translate("Remove")}
                    onCancel={() => setDeleteListItemsModalIsOpen(false)}
                    onSubmit={removeSelectedSubmitHandler}
                    submitTestSelector="buyingListActions_removeItemsModal_submit"
                    data-test-selector="buyingListActions_removeItemsModal"
                ></TwoButtonModal>
            </StyledWrapper>
        </>
    );
};
const widgetModule: CustomWidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(BuyingListActions)),
    definition: {
        group: "Buying List",
        displayName: "Buying List Actions",
    },
};

export default widgetModule;
